import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Subscription } from '../../types/Subscription';
import { AppDispatch } from '../store';
import api from '../../utils/api';

type SubscriptionState = {
  subscription: Subscription | null;
  loading: boolean;
  error: string | null;
  plansLoaded: boolean;
  accountSetupInProgress: boolean;
  accountSetupDone: boolean;
};

const initialState: SubscriptionState = {
  subscription: null,
  loading: false,
  error: null,
  plansLoaded: false,
  accountSetupInProgress: false,
  accountSetupDone: false
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscription: (state, action: PayloadAction<Subscription | null>) => {
      state.subscription = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetSubscription: (state) => {
      state.subscription = null;
      state.loading = false;
      state.error = null;
      state.plansLoaded = false;
      state.accountSetupInProgress = false;
      state.accountSetupDone = false;
    },
    setPlansLoaded: (state, action: PayloadAction<boolean>) => {
      state.plansLoaded = action.payload;
    },
    setAccountSetupInProgress: (state, action: PayloadAction<boolean>) => {
      state.accountSetupInProgress = action.payload;
    },
    setAccountSetupDone: (state, action: PayloadAction<boolean>) => {
      state.accountSetupDone = action.payload;
    }
  }
});

export const subscriptionAction = () => async (dispatch: AppDispatch, getState: () => { subscription: SubscriptionState }) => {
  const state = getState();
  // Only fetch if subscription is not already loaded
  if (state.subscription.subscription !== null) {
    return;
  }
  
  try {
    dispatch(setLoading(true));
    const { data } = await api.get<Subscription>('/subscriptions/v1/users/me/plan');
    dispatch(setSubscription(data));
  } catch (error) {
    console.error(error, 'Error is genereted while featching the date of plan');
  }finally{
    dispatch(setLoading(false));
  }
};

export const { setSubscription, setLoading, setError, resetSubscription, setPlansLoaded, setAccountSetupInProgress, setAccountSetupDone } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;